import { render, staticRenderFns } from "./SessionInfo.vue?vue&type=template&id=ca63e806&scoped=true&lang=pug&"
import script from "./SessionInfo.vue?vue&type=script&lang=js&"
export * from "./SessionInfo.vue?vue&type=script&lang=js&"
import style0 from "./SessionInfo.vue?vue&type=style&index=0&id=ca63e806&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca63e806",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
